export default "__VITE_ASSET__DXD$Hk$P__"